import {
    AutocompleteArrayInput,
    Filter,
    ReferenceArrayInput,
    ReferenceInput,
    TextInput,
} from "react-admin";
import { RaSelectInput } from "shared/src/components/inputs/Ra/RaSelectInput";
import { RaAutocompleteInput } from "../../components/inputs/Ra/RaAutocompleteInput";
import { RaTextInput } from "../../components/inputs/Ra/RaTextInput";
import { Box } from "@mui/material";
import { memo } from "react";

const filterToQuery = (input) => ({ name: input });
const defaultSort = { field: "name", order: "ASC" };
const massProductChoices = [
    {
        id: "0",
        name: "equip.individualSkus",
    },
    { id: "1", name: "equip.massProduct" },
];

export const CategoryListFilter = memo((props) => {
    return (
        <Box
            sx={{
                "& div": {
                    "& input": {
                        minWidth: 90,
                        maxWidth: 160,
                    },
                },
                px: 2,
            }}
        >
            <Filter {...props}>
                <RaTextInput source="name" variant="outlined" alwaysOn />
                <TextInput source="description" alwaysOn variant="outlined" />
                <TextInput source="labelNumber" alwaysOn variant="outlined" />
                <TextInput label="equip.edispo.id" source="edispoId" alwaysOn variant="outlined" />
                <RaSelectInput
                    source="isMassProduct"
                    label="equip.type"
                    variant="outlined"
                    choices={massProductChoices}
                    alwaysOn
                />
                <ReferenceArrayInput
                    source="tags"
                    reference="tags"
                    alwaysOn
                    enableGetChoices={({ name }) => !!(name && name.length >= 0)}
                    loadingText={""}
                >
                    <AutocompleteArrayInput variant="outlined" filterToQuery={filterToQuery} />
                </ReferenceArrayInput>
                <ReferenceInput
                    alwaysOn
                    source="supplier"
                    reference="suppliers"
                    sort={defaultSort}
                    enableGetChoices={({ name }) => !!(name && name.length >= 0)}
                    loadingText={""}
                >
                    <RaAutocompleteInput variant="outlined" label="equip.supplier" field="name" />
                </ReferenceInput>
                <ReferenceInput
                    alwaysOn
                    source="manufacturer"
                    reference="manufacturers"
                    sort={defaultSort}
                    enableGetChoices={({ name }) => !!(name && name.length >= 0)}
                    loadingText={""}
                >
                    <RaAutocompleteInput
                        variant="outlined"
                        label="equip.manufacturer"
                        field="name"
                    />
                </ReferenceInput>
            </Filter>
        </Box>
    );
});
